export const getShadowModeParams = (): { shadowMode: 'true' } | undefined => {
  const shadowMode = new URLSearchParams(window.location.search).get(
    'shadowMode'
  );
  return shadowMode === 'true' ? { shadowMode: 'true' } : undefined;
};
